import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { StudyData } from 'src/app/common/models/chatbotexpand.model';
import { results } from 'src/app/common/models/common.model';
import { protectedResources } from 'src/app/auth.config';
import { DataTransformersHelper } from '../table/data-transformers.helper';
import { CHART_TYPES } from '../../constants/chatbot-expand.constants';

export class SessionStateHelper {
  static resetSessionState(comp: any): void {
    // 1. Reset Toggle States
    comp.isTranspose = false;
    comp.isHideNA = false;
    comp.isTotal = false;
    comp.chartType = CHART_TYPES.COLUMN;
    comp.is_TransposeBtn = false;
    comp.is_chart_visualization = false;
    comp.isVerticalBarChartClick = false;
    comp.isLineChartClick = false;
    comp.isVerticalStackChartClick = false;
    comp.isVerticalGroupBarChartClick = false;
    comp.disableStackChart = false;
    comp.disableLineChart = false;
    comp.StackFlag = false;
    comp.isData = true;
    comp.isWeightedLabel = false;
    comp.isSampleSizeBlock = false;
    comp.isWeightedSampleBlock = false;
    comp.isWeightedNumerator = false;
    comp.isUnWeightedNumerator = false;
    comp.isTotalBase = true;
    comp.isAnswerBase = false;
    comp.isReference = false;
    comp.isSig = true;
    comp.isIndex = false;
    comp.isTrendActive = false;
    comp.isTrendAvailable = false;
    comp.displayTable = false;
    comp.isTableView = false;
    comp.isChartView = true;
    comp.isListView = true;
    comp.isTableClick = false;
    comp.selectedDataFormat = '';
    comp.failedCase = false;
    comp.noContentFlag = false;
    comp.isInsightspopupOpen = false;
    comp.errorHeader = '';

    const defaultWeightObj = comp.configWeights?.find((x: any) =>
      x.is_default === true ||
      x.is_active === true ||
      x.is_default_weight === true ||
      x.default === true
    );
    let matchedDropdown;
    if (defaultWeightObj) {
      matchedDropdown = comp.WeightDropDownList?.find((w: any) => w.responseCode === defaultWeightObj.variable_code || (defaultWeightObj.variable_label === 'Unweighted' && w.Label === 'Unweighted'));
    }

    if (matchedDropdown) {
      comp.selectedWeight = matchedDropdown.responseCode;
      comp.DefaultWeight = matchedDropdown.Label;
    } else {
      let defaultFallback = null;
      defaultFallback = comp.WeightDropDownList?.find((w: any) => w.Label !== 'Unweighted' && w.Label !== 'Boost Factor');
      if (defaultFallback) {
        comp.selectedWeight = defaultFallback.responseCode;
        comp.DefaultWeight = defaultFallback.Label;
      } else {
        const unweighted = comp.WeightDropDownList?.find((w: any) => w.Label === 'Unweighted' || w.responseCode === 'Unweighted');
        if (unweighted) {
          comp.selectedWeight = unweighted.responseCode;
          comp.DefaultWeight = unweighted.Label;
        } else if (comp.WeightDropDownList && comp.WeightDropDownList.length > 0) {
          comp.selectedWeight = comp.WeightDropDownList[0].responseCode;
          comp.DefaultWeight = comp.WeightDropDownList[0].Label;
        } else {
          comp.selectedWeight = '';
          comp.DefaultWeight = '';
        }
      }
    }

    comp.selectedIndex = '';
    comp.threshold = '';
    comp.SignificanceVsReference = '';

    // 3. Reset Data Caches / Global Objects
    comp.CrossTabOutPutEntireData = [];
    comp.CrossTabOutPutData = [];
    comp.insightsVal = [];
    comp.insightsStreamingText = '';
    comp.insightsStreamingPoints = [];
    comp.snapshotinsights_standard_text = '';
    comp.snapshotinsights_trendline_text = '';
    
    if (comp.multiViewInsightsCache) {
      delete comp.multiViewInsightsCache['current'];
    }

    comp.chatPayload = null;
    comp.parallelChatPayload = null;
    comp.lastCrosstabPayload = null;
    comp.lastSnapshotPayload = null;
    comp.lastBrandAnalysisPayload = null;
    comp.lastBrandAnalysisOriginalPipes = null;
    comp.insights_payload = null;
    comp.snapshotinsights_payload = null;
    comp.snapshotinsights_trend_payload = null;
    comp.filteredWidgetData = null;
    comp.filteredWidgetID = null;

    comp.selectionSummary = '';
    comp.defaultQuestionAnswer = 'Answering question...';

    comp.LineChart = { title: '', Data: [], Properties: [] };
    comp.StackChart = { title: '', Data: [], Properties: [] };
    comp.BarChart = { title: '', Data: [], Properties: [] };

    comp.dataObject = { Row: [], Column: [], RowNesting: [], ColNesting: [], Filter: [], CustomGroup: [], CustomCalculation: [] };
    comp.OutputdataObject = { Row: [], Column: [], RowNesting: [], ColNesting: [], Filter: [], CustomGroup: [], CustomCalculation: [] } as any;

    // 4. Reset Multi-View States
    comp.availableViews = [];
    comp.activeView = null;
    comp.allMemberResponses = null;
    comp.orchestrationRawData = null;

    // 5. Reset Dropdowns/Panels
    comp.sampleSizeDropdown = false;
    comp.confidenceLevelDropDown = false;
    comp.referenceLevelDropDown = false;
    comp.BaseDropDownToggle = false;
    comp.weightDropDown = false;
    comp.dataDropDown = false;
  }

  static handleMetadataPreFetchResponse(comp: any, data: any): void {
    if (!data) return;

    let parsedData: any = null;
    try {
      if (data.Data && data.Data !== '') {
        parsedData = (typeof data.Data === 'string') ? JSON.parse(data.Data) : data.Data;
      } else if (data.Config && data.Config !== '') {
        parsedData = (typeof data.Config === 'string') ? JSON.parse(data.Config) : data.Config;
      } else {
        parsedData = data;
      }
    } catch (e) {
      parsedData = data.Data || data;
    }

    if (parsedData && parsedData.configData) {
      parsedData = parsedData.configData;
    }

    comp._configService.outputSnapshotData = parsedData;
    comp.masterStudyConfig = parsedData;

    if (parsedData.custom_logo_path && !comp.clientLogo) {
      comp.clientLogo = parsedData.custom_logo_path;
    }

    if (parsedData.brandMetadata) comp._configService.brandData = parsedData.brandMetadata;
    else if (parsedData.brand_metadata) comp._configService.brandData = parsedData.brand_metadata;

    const weightsRaw = parsedData.weight || parsedData.weights;
    if (weightsRaw && Array.isArray(weightsRaw) && weightsRaw.length > 0) {
      comp._configService.weights = weightsRaw;
      comp.configWeights = weightsRaw;

      comp.populateWeightDropdown();

      const selectedWeights = Array.isArray(weightsRaw)
        ? weightsRaw.filter((w: any) => w.is_selected || w.isSelected)
        : [];
      const firstWeight = selectedWeights.length > 0 ? selectedWeights[0]
        : (Array.isArray(weightsRaw) ? weightsRaw[0] : null);
      if (firstWeight) {
        const allSelected = selectedWeights.length > 0 ? selectedWeights : (Array.isArray(weightsRaw) ? weightsRaw : []);
        const idx = allSelected.indexOf(firstWeight);
        const label = (comp.WeightDropDownList && comp.WeightDropDownList.length > idx) 
          ? comp.WeightDropDownList[idx].Label 
          : (firstWeight.variable_label || firstWeight.key || `Weight ${idx + 1}`);
        comp._configService.weightLabel = label;
        if (!comp.DefaultWeight) {
          comp.DefaultWeight = label;
        }
      }
    }

  }

  static syncDataObjectFromPrompt(comp: any, res: any) {
    if (!res) return;

    const rowData = res.Row || res.row || [];
    const colData = res.Column || res.column || [];
    const colNestData = res.ColNesting || res.col_nesting || res.column_nesting || res.Column_Nesting || [];
    const rowNestData = res.RowNesting || res.row_nesting || res.Row_Nesting || [];
    const filters = res.Filter || res.filters || res.Filters || {};

    // Row/Column/Nesting may already arrive pre-structured as [{ Parent, Data }] (e.g. when sourced
    // from crosstab_payload / brand_analysis_payload on a fresh AI question) instead of flat
    // "Parent|Child" strings (e.g. when sourced from chat history). transformToDataObject only
    // understands the flat string form, so pass already-structured arrays through unchanged.
    const toDataObjectArray = (arr: any, fallbackType: string) =>
      Array.isArray(arr) && arr.length > 0 && typeof arr[0] !== 'string'
        ? arr
        : DataTransformersHelper.transformToDataObject(comp, arr, fallbackType);

    comp.dataObject.Row = toDataObjectArray(rowData, 'Row');
    comp.dataObject.Column = toDataObjectArray(colData, 'Column');
    comp.dataObject.ColNesting = toDataObjectArray(colNestData, 'ColNesting');
    comp.dataObject.RowNesting = toDataObjectArray(rowNestData, 'RowNesting');

    const getTrueSortId = (responseCode: string, parentName: string) => {
      if (!comp.variableTabData) return undefined;
      let v = comp.variableTabData.find((item: any) => 
        item.response_code === responseCode && 
        (item.Level0 === parentName || item.Level1 === parentName || (parentName && item.Level1 && parentName.includes(item.Level1)))
      );
      if (!v) {
        v = comp.variableTabData.find((item: any) => item.response_code === responseCode);
      }
      return v && v.sort_id !== undefined && v.sort_id !== null ? Number(v.sort_id) : undefined;
    };

    const sortDataBySortId = (groups: any[], label: string) => {
      if (!Array.isArray(groups)) return;
      groups.forEach((group: any) => {
        if (Array.isArray(group.Data) && group.Data.length > 0) {
          group.Data.forEach((d: any) => {
            const trueSortId = getTrueSortId(d.responsecode || d.CheckboxStatus, group.Parent);
            d.true_sort_id = trueSortId !== undefined ? trueSortId : (d.sort_id ?? 0);
          });
          group.Data.sort((a: any, b: any) => (a.true_sort_id ?? 0) - (b.true_sort_id ?? 0));
        }
      });
    };
    sortDataBySortId(comp.dataObject.Row, 'Row');
    sortDataBySortId(comp.dataObject.Column, 'Column');
    sortDataBySortId(comp.dataObject.ColNesting, 'ColNesting');
    sortDataBySortId(comp.dataObject.RowNesting, 'RowNesting');

    let filterList: any = filters;
    if (!Array.isArray(filters) && typeof filters === 'object' && filters !== null) {
      filterList = [];
      Object.values(filters).forEach((val: any) => {
        if (Array.isArray(val)) filterList.push(...val);
        else if (typeof val === 'string' && val.trim() !== '') filterList.push(val);
      });
    }
    comp.dataObject.Filter = toDataObjectArray(filterList, 'Filter');
    comp.OutputdataObject = {
      ...(comp.OutputdataObject || {}),
      Filter: comp.dataObject.Filter,
      RowNesting: comp.dataObject.RowNesting,
      ColNesting: comp.dataObject.ColNesting
    } as any;
  }

  static getBearerToken(comp: any): Promise<string>  {
    return new Promise((resolve) => {
      let account = comp.msalService.instance.getActiveAccount();
      if (!account) {
        const accounts = comp.msalService.instance.getAllAccounts();
        if (accounts && accounts.length > 0) {
          account = accounts[0];
          comp.msalService.instance.setActiveAccount(account);
        }
      }
      if (!account) {
        resolve('');
        return;
      }
      comp.msalService.instance.acquireTokenSilent({
        scopes: protectedResources.Api.scopes.read,
        account: account
      }).then((tokenResponse: any) => {
        resolve(`Bearer ${tokenResponse.accessToken}`);
      }).catch((error: any) => {
        console.error('Token acquisition failed in chatbotexpand', error);
        resolve('');
      });
    });
  }

  static async fetchStudyDataAsync(comp: any, fromLandingPage: boolean) {
    let result: results | null = await comp.indexedDBService.getClientStudyData(
      comp.selected_client,
      comp.selected_study,
      comp.isBrandAnalysis
    );

    if (!result) {
      try {
        result = await firstValueFrom(
          comp.crossTabService.getClientStudyData(
            {
              client_code: comp.selected_client,
              study: comp.selected_study,
            },
            comp.isBrandAnalysis
          )
        );

        if (result && result.HasValidData) {
          await comp.indexedDBService.cacheClientStudyData(
            comp.selected_client,
            comp.selected_study,
            comp.isBrandAnalysis,
            result
          );
        }
      } catch (err) {
        console.error("Failed to load study data:", err);
      }
    }

    if (result && result.HasValidData) {
      const studyData: StudyData = {
        study: comp.selected_study,
        client_name: comp.selected_client,
        url_logo: comp.filteredlist?.url_logo || '',
      };
      comp.receivedData = JSON.parse(result.Data);
      comp.clientcode = comp.selected_client;
      comp.filteredlist = comp.receivedData.find(
        (u: StudyData) =>
          u.study === comp.selected_study &&
          u.client_name === comp.selected_client
      );

      comp.logo_url = comp.filteredlist?.url_logo || '';

      if (comp.selected_client === 'PMI') {
        comp.configChanges(comp.receivedData, comp.selected_study);
      }

      if (!comp.variableTabData || comp.variableTabData.length === 0) {
        const fetchArray = [{ clientName: comp.selected_client, studyName: comp.selected_study }];
        comp.crossTabService.getVariableData(fetchArray, comp.isBrandAnalysis).subscribe((res: any) => {
          if (res && res.HasValidData) {
            comp.variableTabData = JSON.parse(res.Data);
            comp.crossTabService.setVariableTabData(comp.variableTabData);
            if (comp.configWeights && comp.configWeights.length > 0) {
              comp.populateWeightDropdown();
            }
          }
        });
      }

      if (fromLandingPage) {
        comp.processSendMessageRequest();
      } else {
        comp.loadLatestChatIfExists();
      }
    } else {
      comp.router.navigateByUrl('/landing');
    }
  }

  static async _initializeUserIdentityCore(comp: any): Promise<void>  {
    try {
      const storedUserId = sessionStorage.getItem('arkUserId');

      if (storedUserId) {
        const response = await firstValueFrom(comp.apiService.getUserIdentity(storedUserId));
        const apiResponse = JSON.parse(response as string);

        if (apiResponse.HasValidData && apiResponse.Data) {
          const userData = JSON.parse(apiResponse.Data);
          comp.userId = userData.UserId;
          return;
        }
      }
      await comp.createNewUserIdentity();
    } catch (error) {
      console.warn('[User Identity] Failed to fetch stored user, creating new one...', error);
      await comp.createNewUserIdentity();
    }
  }

  static initializeUserIdentity(comp: any): Promise<void>  {
    if (!comp.userIdentityPromise) {
      comp.userIdentityPromise = comp._initializeUserIdentityCore().then(() => {
        comp.isIdentityLoaded = true;
        comp.checkHistoryReady();
      }).catch((error: any) => {
        console.error('[User Identity] Initialization failed:', error);
        comp.userIdentityPromise = null;
        comp.isIdentityLoaded = true;
        comp.checkHistoryReady();
      });
    }
    return comp.userIdentityPromise;
  }

  static handleConfig(comp: any, eventData: any): void  {
    if (eventData) {
      comp.isWeigthedBtn = eventData.weighted_btns;
    }
    if (eventData.configweights && eventData.configweights.length > 0) {
      comp.configWeights = eventData.configweights;

      if (comp.variableTabData && comp.variableTabData.length > 0) {
        comp.populateWeightDropdown();
      }
    }
  }

  static performAccessCheck(comp: any): void {
    if (!comp.validatedSessionId || comp.validatedSessionId !== comp.guidChatId) {
      comp.getBearerToken().then((token: any) => {
        comp.apiService.accessCheck(
          comp.selected_client || '',
          comp.selected_study || '',
          token,
          comp.guidChatId || ''
        ).subscribe({
          next: (res: any) => {
            if (res && res.session_id) {
              comp.guidChatId = res.session_id;
              comp.modulesAccess = res.modules_access;
              comp.isCacheGenerated = false;
            }
            comp.validatedSessionId = comp.guidChatId;
          },
          error: (err: any) => {
            console.error('[ACCESS-CHECK] Init access-check failed:', err);
          }
        });
      });
    }
  }

  static loadBranding(comp: any): void {
    if (comp.selected_client) {
      try {
        forkJoin([
          comp._configurationService.getLogo(comp.selected_client).pipe(catchError(() => of(null))),
          comp._configurationService.getLogoFiles(comp.selected_client).pipe(catchError(() => of([])))
        ]).subscribe({
          next: (res: any) => {
            const [logoRes, filesRes] = res;

            let finalLogo: string | null = null;
            let finalLogoUrl: string = comp.logo_url;

            if (filesRes && filesRes.length > 0) {
              const askme = filesRes.find((f: any) => f.fileName && f.fileName.toLowerCase().endsWith('_askme.png'));
              const normal = filesRes.find((f: any) => f.fileName && !f.fileName.toLowerCase().endsWith('_askme.png'));

              if (askme?.url) {
                finalLogo = askme.url;
                finalLogoUrl = askme.url;
              } else if (normal?.url) {
                finalLogo = normal.url;
                finalLogoUrl = normal.url;
              }
            }
            if (!finalLogo && logoRes) {
              if (logoRes.url) {
                finalLogo = logoRes.url;
              } else if (logoRes.HasValidData && logoRes.Data) {
                try {
                  const parsed = JSON.parse(logoRes.Data);
                  finalLogo = parsed.url || parsed;
                } catch (e) {
                  finalLogo = logoRes.Data;
                }
              }
            }
            comp.clientLogo = finalLogo;
            comp.logo_url = finalLogoUrl || comp.logo_url;
            comp.isBrandingLoaded = true;
          },
          error: (err: any) => {
            console.warn('[LOGO-DEBUG] Branding orchestration error:', err);
            comp.isBrandingLoaded = true;
          }
        });
      } catch (e) {
        console.warn('[LOGO-DEBUG] Exception during branding setup:', e);
        comp.isBrandingLoaded = true;
      }
    } else {
      comp.isBrandingLoaded = true;
    }
  }
}
